export class HttpRequestCancelToken {
  // TODO: SDK 需要导出到sdk
  #controller = new AbortController()
  #isCancelled = false

  get signal() {
    return this.#controller.signal
  }

  get isCancelled(): boolean {
    return this.#isCancelled
  }

  cancel() {
    this.#controller.abort()
    this.#isCancelled = true
  }
}
